module.exports = __webpack_public_path__ + "img/pack-yes.d0e7e87b.png";